import React from 'react';
import { Link } from 'react-router-dom';

import { Tooltip } from '@components';

import './ContentDatabaseItem.scss';

export const ContentDatabaseItem = ({
  businessID,
  datamodelItem,
  datamodelsData,
}) => {
  // filter datamodels to match the associated type
  const datamodelMatch = datamodelsData
    ? datamodelsData.objects.filter(
        (datamodel) => datamodel.id == datamodelItem.datamodel_id,
      )
    : null;
  // datamodel item type to display
  const datamodelName = datamodelMatch ? datamodelMatch[0].name : null;

  return (
    <div className="sb-row-item">
      <div className="sb-row--datamodel-item-name">
        <p>
          <b>
            <Link
              to={`/dashboard/projects/${businessID}/contentitems/${datamodelItem.id}`}
            >
              {datamodelItem.name}
            </Link>
          </b>
        </p>
      </div>
      <div className="sb-row--datamodel-item-type">
        <p>
          {!datamodelsData && <span>...</span>}
          {datamodelsData && datamodelName && (
            <Tooltip tooltip={`Content database item of type ${datamodelName}`}>
              {datamodelName}
            </Tooltip>
          )}
        </p>
      </div>
    </div>
  );
};
